import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const ThankYou = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  // Countdown effect
  useEffect(() => {
    if (countdown === 0) {
      window.location.href = "/"; 
      return;
    }

    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  return (
    <div className="thankyou-wrapper">
      <h1>🎉 Application Submitted Successfully!</h1>
      <p>Thank you for submitting your application. We will contact you shortly.</p>
      <p className="redirect-text">
        Redirecting to home page in <strong>{countdown}</strong> seconds...
      </p>
      <a className="btn btn-primary btn-submit-custom mt-2" href="/">Go Now</a>
    </div>
  );
};

export default ThankYou;